import { combineReducers } from 'redux';
import account from './account.reducer';

const reducer = combineReducers({
	account
});

export default reducer;
